/** PROFFIT SEARCHの月額利用料金（税抜） */
export const PROFFIT_SEARCH_PRICE = 10000;
export const PROFFIT_SEARCH_PLAN_FUNCTIONS_ACCOUNT_PAGE = [
    '資料の受領機能\n（受領資料の検索・利用）',
    '資料アップロード機能',
    '資料のPPT化／作成機能',
    '資料の共有機能',
];
export const PROFFIT_SEARCH_PLAN_FUNCTIONS_LP_PAGE = [
    ...PROFFIT_SEARCH_PLAN_FUNCTIONS_ACCOUNT_PAGE,
    '提案書作成支援機能',
];
export const PROFFIT_SEARCH_PLAN_TRIAL = {
    functions: [true, true, true, true, false],
    price: 0,
    short: 'トライアル',
    title: 'トライアルプラン',
    value: 'trial',
};
export const PROFFIT_SEARCH_PLAN_FREE = {
    functions: ['上限\n30枚', false, false, false, false],
    limit: 30,
    price: 0,
    short: 'フリー',
    title: 'フリープラン',
    value: 'free',
};
export const PROFFIT_SEARCH_PLAN_STANDARD = {
    functions: [true, true, true, true, false],
    isRecommended: true,
    price: PROFFIT_SEARCH_PRICE,
    short: 'スタンダード',
    title: 'スタンダードプラン',
    value: 'standard',
};
export const PROFFIT_SEARCH_PLAN_ADVANCED = {
    functions: [true, true, true, true, true],
    short: 'アドバンスド',
    title: 'アドバンスドプラン',
    value: 'advanced',
};
export const PROFFIT_SEARCH_PLANS = [
    PROFFIT_SEARCH_PLAN_TRIAL,
    PROFFIT_SEARCH_PLAN_FREE,
    PROFFIT_SEARCH_PLAN_STANDARD,
    PROFFIT_SEARCH_PLAN_ADVANCED,
];
export const PROFFIT_SEARCH_ACTION_TOOLTIP_BLOCK_SHARE = '共有NGのスライドが選択されています';
export const PROFFIT_SEARCH_ACTION_TOOLTIP_IS_NOT_READY_PPTX = '変換中のスライドが選択されています';
export const PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN = 'スタンダードプラン限定';
export const PROFFIT_SEARCH_WARNING_EXPIRE_APPROACH = 'アカウントの期限が迫っています。アカウント管理ページから更新してください。';
export const getProffitSearchWarningMemberExpireApproach = (count) => `アカウントの期限が迫っているメンバーが${count}人います。アカウント管理ページから更新してください`;
export const PROFFIT_SEARCH_WARNING_FREE_ACCOUNT = '利用していないアカウントがあります。アカウント管理ページからメンバーを追加いただけます';
export const PROFFIT_SEARCH_WARNING_UNREAD_SLIDE = '未読のメッセージがあります。受信ファイルから確認してください。';
